module.exports = __webpack_public_path__ + "media/images/application/template/products/homepage_small_containers_desktop-075bde38e11f9a759636df906b6585da.png";